import React from "react";

function Input(props) {
  const { className, type, value, onChange, placeholder, name, onKey } = props;
  return (
    <input
      className={className}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      name={name}
      onKeyPress={onKey}
    />
  );
}

export default Input;
